"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VerticalScroll = void 0;
var react_1 = __importStar(require("react"));
require("./index.less");
/**
 * 竖向滚动
 * @returns
 */
function VerticalScroll(props) {
    var movetime = props.movetime || 25;
    var switchtime = props.switchtime || 5000;
    var thisul = (0, react_1.useRef)(null);
    var thiscontent = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(function () {
        if (!thisul.current || !thiscontent.current || props.htmllist.length < 2)
            return;
        //计算高度
        var thisuldom = thisul.current;
        var thiscontentdom = thiscontent.current;
        var ul_height = thisuldom.clientHeight / 2;
        var li_height = thisuldom.querySelector('li').clientHeight;
        // console.info(ul_height, li_height)
        thisuldom.style.height = li_height + 'px';
        var scrolltop = 0;
        var movecd = null;
        var moveto = 0;
        var moveOneStep = function () {
            moveto = scrolltop + li_height;
            clearInterval(movecd);
            movecd = setInterval(function () {
                scrolltop++;
                if (moveto >= ul_height + li_height) {
                    scrolltop = 1;
                    moveto = li_height;
                }
                if (scrolltop >= moveto) {
                    clearInterval(movecd);
                }
                else {
                    thiscontentdom.scrollTop = scrolltop;
                }
            }, movetime);
        };
        var autocd = setInterval(function () {
            moveOneStep();
        }, switchtime);
        document.addEventListener('visibilitychange', function () {
            if (document.hidden) {
                clearInterval(movecd);
            }
            scrolltop = 0;
            moveto = 0;
        });
        return function () {
            scrolltop = 0;
            clearInterval(movecd);
            clearInterval(autocd);
        };
    }, [props.htmllist]);
    return (react_1.default.createElement("div", { className: "vscroll", ref: thiscontent },
        react_1.default.createElement("ul", { ref: thisul },
            props.htmllist.map(function (v, index) {
                return react_1.default.createElement("li", { key: index, dangerouslySetInnerHTML: { __html: v } });
            }),
            props.htmllist.map(function (v, index) {
                return react_1.default.createElement("li", { key: index, dangerouslySetInnerHTML: { __html: v } });
            }))));
}
exports.VerticalScroll = VerticalScroll;
